import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group';
import styled from 'styled-components';

class FullWrapper extends React.Component {
    static count = 0;

    componentDidMount() {
        $('body').addClass('noscroll');
        FullWrapper.count++;
    }

    componentWillUnmount() {
        FullWrapper.count--;
        if (FullWrapper.count === 0) {
            $('body').removeClass('noscroll');
        }
    }

    render() {
        return (
            <Cmp key="wrapper">
                {this.props.children}
            </Cmp>
        );
    }
}

const Cmp = styled.div`
    position: fixed;
    overflow: hidden;
    z-index: 999999;
    width: 100%;
    top: 0;
    bottom: 0;
    
    .btn-close {
        position: absolute;
        right: 1rem;
        top: .5rem;
        color: #fff;
    }
`;

export default FullWrapper;

export const Content = styled.div`
    position: absolute;
    left: 0;
    width: 100%;
    top: 0;
    padding-top: 50px;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
`;



// WEBPACK FOOTER //
// ./src/marathons/components/FullWrapper.jsx